<template>
    <div class="profile">
        <div class="header">
            <div class="header-left" @click="back">
              <span class="iconfont iconzuojiantou"></span>
            </div>
            <div class="header-center">
                <P>我的</P>
            </div>
            <div class="header-right"></div>
        </div>
        <div class="user" @click="toProfileSettin">
            <div class="userImg"><img :src="user.CustomerHeadImg ? user.CustomerHeadImg : require('../../assets/img/default_avatar.png')" alt=""></div>
            <div class="userInfo">
                <div class="userName">{{user.CustomerNickName}} {{user.CustomerPhone}}</div>
                <!-- <div class="userCoupons">我的现金券：￥0.00</div>
                <div class="userIntegral">我的积分： 0</div> -->
            </div>
            <div class="userLeft">
              <span class="iconfont iconyoujiantou"></span>
            </div>
        </div>
        <div class="icon">
            <!-- <div class="shop"><span class="iconfont icondingdan"></span>商城订单</div> -->
            <div class="service" @click="toOrderList"><span class="iconfont icondingdanyichenggong"></span>服务订单</div>
            <!-- <div class="shopping"><span class="iconfont icontuangou"></span>我的一起购</div> -->
            <!-- <div class="coupons"><span class="iconfont iconunie648"></span>优惠券</div> -->
            <div class="address" @click="toAddressDirectories"><span class="iconfont icondizhi"></span>地址管理</div>
            <!-- <div class="null"></div> -->
        </div>
        <div class="button">
           <van-button size="normal" class="out" @click="out">退出</van-button>
        </div>
        
    </div>
</template>

<script>
import { Dialog } from 'vant'
export default {
  computed: {
    user () {
      return this.$store.state.user
    }
 },
 created () {
      if (localStorage.getItem('kjToken') || this.cookieUtil.getCookie('kjToken')) {
         
        this.$axios.get('/api/DjUser/GetLoginInfo').then(res => {
          if(res.data.type == 1){
             //console.log(res.data)
              //const { Token } = res.data
              // console.log(Token)
              // 存储到ls
             // localStorage.setItem('kjToken', Token)
             this.$store.dispatch('getUser', res.data)
             // this.$router.push("/profile")
            }
        })
      }
  },
 methods: {
   out () {
     Dialog.confirm({
        title: '确认退出？',
        message: '确认将退出登录'
        }).then(() => {
            localStorage.removeItem('kjToken')
            localStorage.removeItem('TownStreetName')
            localStorage.removeItem('TownStreet')
            this.cookieUtil.delCookie('kjToken')
          // 设置vuex
          this.$store.dispatch('clearUser')
          this.$axios.defaults.headers.common['Authorization'] = ''
          // 跳转
          this.$router.push('/wxlogin')
        }).catch(() => {
        
        });
     
   },
   back () {
     this.$router.push('/')
   },
   toProfileSettin () {
     this.$router.push('/profileSettin')
   },
   toAddressDirectories () {
     this.$router.push('/addressdirectories')
   },
   toOrderList () {
     this.$router.push('/orderlist')
   }
 }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.profile
  background: #F5F5F5
  height: 100vh
  .header
   z-index: 90
   display: flex
   justify-content: space-between
   width: 100%
   height: 40px
   align-items: center
   background-color: white
   .header-left
     padding-left: 8px
   .header-right
     padding-right: 8px
   .header-center
     font-size: 20px
 .user
   background: #F5F5F5
   margin-top: 4px
   display: flex
   justify-content: space-between
   align-items: center
   .userImg
     margin-left: 18px
     border-radius: 50%
     padding: 6px 0
     &>img
      margin: auto
      width: 70px
      height: 70px
      border-radius: 50%
   .userInfo
     width: 70%
     margin: 6px 6px 6px 12px
     font-size: 14px
     color: #525252
     &>.userCoupons
      margin: 10px 0
   .userLeft
     display: flex
     align-items: center
     &>span
      font-size: 25px
      margin-right: 5px
 .icon
   display: flex
   flex-wrap: wrap
   width: 100%
   &>div
    width: 50%
    padding: 16px 0
    border: 1px solid #eee
    box-sizing: border-box
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    background: white
    font-size: 14px
    color: #333
    &:nth-child(1)
      border-right: none
      
    &>span 
       font-size: 30px
       color: red
       margin-bottom: 6px
 .button
   width: 100%
   text-align: center
   &>.out
     width: 90%
     margin: 10px auto
     -webkit-border-radius: 30px
     background: #04BE02
     color: white

</style>



// WEBPACK FOOTER //
// src/pages/Profile/Profile.vue